const AttributeKeys = ["attr0", "attr1", "attr2", "attr3"];
export { AttributeKeys };
